
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class DialogBase extends Vue {
  @Prop({ default: "阅读指引" }) title!: string; // 自定义传过来的title
}
